export default __webpack_public_path__ + "03cbb2d51ac90e471fd398ba24e9da71.jpg";